const ParameterActions = {
  SetParameters: 0,
};

const setParameters = (parameters) => {
  return {
    type: ParameterActions.SetParameters,
    payload: {
      parameters: parameters,
    },
  };
};

export {ParameterActions, setParameters}
